import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import '@/styles/index.css';
import '@/fonts/iconfont.css';
import { Button } from 'vant';
Vue.use(Button);
import { Cell, CellGroup } from 'vant';
Vue.use(Cell);
Vue.use(CellGroup);
import { Icon } from 'vant';
Vue.use(Icon);
import { Image as VanImage } from 'vant';
Vue.use(VanImage);
import { Col, Row } from 'vant';
Vue.use(Col);
Vue.use(Row);
import { Popup } from 'vant';
Vue.use(Popup);
import { Toast } from 'vant';
Vue.use(Toast);
import { Checkbox, CheckboxGroup } from 'vant';
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
import { Field } from 'vant';
Vue.use(Field);
import { Form } from 'vant';


import { Locale } from 'vant';
import zhCN from 'vant/lib/locale/lang/zh-CN';

Locale.use('zh-CN', zhCN);


Vue.use(Form);
import { RadioGroup, Radio } from 'vant';

import { Dialog } from 'vant';
Vue.use(Dialog);

Vue.use(Radio);
Vue.use(RadioGroup);
import { Rate } from 'vant';

Vue.use(Rate);
import { Search } from 'vant';

Vue.use(Search);
import { Stepper } from 'vant';

Vue.use(Stepper);
import { Uploader } from 'vant';

Vue.use(Uploader);
import { DropdownMenu, DropdownItem } from 'vant';

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
import { Loading } from 'vant';

Vue.use(Loading);
import { Collapse, CollapseItem } from 'vant';

Vue.use(Collapse);
Vue.use(CollapseItem);
import { CountDown } from 'vant';

Vue.use(CountDown);
import { Divider } from 'vant';

Vue.use(Divider);
import { Empty } from 'vant';

Vue.use(Empty);
import { Step, Steps } from 'vant';

Vue.use(Step);
Vue.use(Steps);
import { Swipe, SwipeItem } from 'vant';

Vue.use(Swipe);
Vue.use(SwipeItem);
import { Tag } from 'vant';

Vue.use(Tag);
import { Tab, Tabs } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);
import { Card } from 'vant';

Vue.use(Card);
import { GoodsAction, GoodsActionIcon, GoodsActionButton } from 'vant';

Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
import { Sku } from 'vant';

Vue.use(Sku);
import { List } from 'vant';

Vue.use(List);
import { Picker } from 'vant';

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.use(Picker);
import { Lazyload } from 'vant';
Vue.use(Lazyload);
import { Tabbar, TabbarItem } from 'vant';
Vue.use(Tabbar);
Vue.use(TabbarItem);
import fotter from './views/footer.vue'
Vue.component('v-foot', fotter)
// import draggable from 'vuedraggable'
// Vue.use(draggable)



Vue.config.productionTip = false
Vue.prototype.$axios = axios;

// axios.defaults.baseURL = '/api'
axios.defaults.baseURL = 'https://www.jqxtech.com/'
/**
 * 公共基本数据
 */
Vue.prototype.baseData = {"cart_total":0};
Vue.prototype.sendRequest = function (method, url, data, callback) {
    window.console.debug("=============sendRequest ===========");
    // if (url.indexOf("http") !== 0) {
    //     url = url;
    // }

    if (data == null) {
        data = {};
    }
    //用户信息
    var user_info_tmp = this.getUserInfo();
    window.console.log("-------data-------------");
    window.console.log(data);
    var token = "";
    window.console.log(user_info_tmp);
    if(user_info_tmp){
        if(user_info_tmp.token == undefined || user_info_tmp.token == "undefined"){
            user_info_tmp.token = "";
        }
        token = user_info_tmp.token;
    }
    window.console.log("token=-------"+token+"----------=token");
     //token = "123456";
    this.$axios({
        url: url,
        method: method,
        data: data,
        headers:{"application":"h5","token":token}
    }).then(res=>{
        if(res.status === 200){
            if(res.data.code == -400){
                // localStorage.setItem("user_info","");
                this.$cookies.remove('user_info');
            }
            if (callback) {
                callback(res.data);
            } else {
                window.console.warn("not set callback");
            }
        }else{
            window.console.log(res)
        }
    });
}

Vue.prototype.GET = function (url, data, callback) {
    if (data && typeof (data) == 'function') {
        callback = data;
        data = {};
    }
    this.sendRequest('GET', url, data, callback);
}

Vue.prototype.POST = function (url, data, callback) {
    if (data && typeof (data) == 'function') {
        callback = data;
        data = {};
    }
    this.sendRequest('POST', url, data, callback);
}
/**
 * 获取用户信息
 * @param {*} status  true:获取失败，则跳转登录页面
 */
Vue.prototype.getUserInfo = function (status,callback) {
    var user_info = false;
    var user_info_json_str = null;//localStorage.getItem("user_info");
    if(user_info_json_str != null && user_info_json_str!= ""){
        user_info = JSON.parse(user_info_json_str);
    }
    if(!user_info){
        var user_info_temp = this.$cookies.get('user_info');
        if(user_info_temp != null && user_info_temp != ""){
            user_info = user_info_temp;
        }
    }
    if(!user_info && status){
        //跳转登录页面
        this.$router.push('login');
        return user_info;
    }
    if (callback) {
        callback(user_info);
    }
    return user_info;
}
/**
 * 获取用户信息
 * @param {*} status  true:获取失败，则跳转登录页面
 */
Vue.prototype.setUserInfo = function (user_info) {
    if(user_info == -1){
        // localStorage.setItem("user_info",null);
        this.$cookies.remove('user_info');
    }else if(user_info != null && user_info != undefined && Object.keys(user_info).length > 1){
        // localStorage.setItem("user_info",JSON.stringify(user_info));
        this.$cookies.set('user_info',JSON.stringify(user_info));
        return user_info;
    }
    //从cookie中获取
    return false;
}

Vue.prototype.alert = function (message){
    Dialog.alert({
      message: message,
    }).then(() => {
      // on close
    });
}
/**
 * 登陆后，接着执行
 * @param {*} status  
 */
Vue.prototype.gourl_by_login = function (gourl) {
    if(gourl != "" && gourl != undefined){
        this.$router.push(gourl);
        return;
    }
    var buy_now_goods_info_tologin = localStorage.getItem("buy_now_goods_info_tologin");
    if(buy_now_goods_info_tologin != "" && buy_now_goods_info_tologin != null){
        var buy_now_goods_info_tologin_json = JSON.parse(buy_now_goods_info_tologin);
        localStorage.setItem('buy_now_goods_info', buy_now_goods_info_tologin);
        localStorage.removeItem("buy_now_goods_info_tologin");
        this.clearn_gourl_by_login();
        this.$router.push({path: 'pay', query: {ids: buy_now_goods_info_tologin_json.goods_id, buy_type: 'goods'}})
    }else{
        var reg_from = localStorage.getItem('reg_from');
        if(reg_from == ""){
            reg_from = "personal";
        }
        this.clearn_gourl_by_login();
        this.$router.push(reg_from);
    }
}

/**
 * 清理
 * 在跳转之前执行
 * @param {*} status  
 */
Vue.prototype.clearn_gourl_by_login = function () {    
    localStorage.removeItem("buy_now_goods_info_tologin");
    localStorage.removeItem("reg_from");    
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
